import { React, useState, useEffect } from 'react'
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { Helmet } from 'react-helmet'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faCalendar, faPersonWalking, faPersonCircleCheck, faEnvelope, faUsers, faCalendarCheck, faHourglassHalf, faEnvelopeOpenText, faLayerGroup, faPen, faChartSimple, faCircleInfo, faChevronRight } from '@fortawesome/free-solid-svg-icons'

import MainHeader from '../../../components/MainHeader/MainHeader.js'
import MainFooter from '../../../components/MainFooter/MainFooter.js'
import Skeleton from '../../../components/Skeleton/Skeleton.js'

import { lP, oP, sT, boxvar2_1, boxvar4, URL_MAINAPI, API_TOKEN, formatDateWithTime, capFirstChar } from '../../../main.js'

import '../../../main.css'
import './ManageEvent.css'
import './MManageEvent.css'

import Cookies from 'universal-cookie'

export default function ManageEvent() {

    var [resError, setResError] = useState("")

    const cookies = new Cookies()
    let cur_userid = cookies.get('userid')
    let cur_firstname = cookies.get('firstname')
    let cur_lastname = cookies.get('lastname')
    let cur_authtoken = cookies.get('authtoken')
    let loggedin = (cur_userid != "" && cur_userid != undefined)

    var [eventData, setEventData] = useState([])
    var [loadedEventData, setLoadedEventData] = useState(0)
    var [eventStats, setEventStats] = useState([])
    var [loadedEventStats, setLoadedEventStats] = useState(0)

    const { eventid } = useParams();

    useEffect(() => {
        getEventData()
        getEventStats()
    }, [])

    function getEventData() {
        try {
            setLoadedEventData(0)
            fetch(URL_MAINAPI + "/event/" + eventid + "?ignoreinactive=1", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventData(res.data)
                    setLoadedEventData(1)
                } else {
                    setEventData([])
                    setLoadedEventData(0)
                }
            }))
        } catch (err) {
            setEventData([])
            setLoadedEventData(0)
        }
    }

    function getEventStats() {
        try {
            setLoadedEventStats(0)
            fetch(URL_MAINAPI + "/event/stats/" + eventid, {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'APITOKEN': API_TOKEN,
                    'authtoken': cur_authtoken
                },
            }).then(response => response.json().then(data => ({ data: data, status: response.status })).then(res => {
                if (res.status == 200) {
                    setEventStats(res.data)
                    setLoadedEventStats(1)
                } else {
                    setEventStats([])
                    setLoadedEventStats(0)
                }
            }))
        } catch (err) {
            setEventStats([])
            setLoadedEventStats(0)
        }
    }

    return (
        <div className='mainCon page' id='mainCon'>
            <MainHeader selectedsite={""} />
            <Helmet>
                <meta charSet="utf-8" />
                <title>Eventverwaltung</title>
                <meta property="og:title" content="Eventverwaltung" />
                <meta property="og:description" content="Verwalte deine Veranstaltung" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <main className='page-body container section' style={{ paddingTop: '36px' }}>
                {/* Breadcrumb */}
                <div className='breadcrumb'>
                    <a href='/profil'>Meine Organisationen</a>
                    <FontAwesomeIcon icon={faChevronRight} />
                    {eventData.orgid ? (
                        <a href={'/manage/org/' + eventData.orgid}>{eventData.organization ? eventData.organization.name : 'Organisation'}</a>
                    ) : (
                        <span>Organisation</span>
                    )}
                    <FontAwesomeIcon icon={faChevronRight} />
                    <span>{eventData.name || 'Event'}</span>
                </div>

                {/* Title Row */}
                <div className='title-row'>
                    <div>
                        <motion.h1
                            variants={boxvar4}
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: false, margin: "-50px" }}
                            className='section-title'
                            style={{ marginBottom: '6px' }}
                        >
                            {loadedEventData ? eventData.longname : <Skeleton height={30} width="70%" />}
                        </motion.h1>
                        {loadedEventData ? (
                            <span className='title-meta'>
                                {eventData.shortname ? <><b>Shortname:</b> {eventData.shortname}</> : null}
                            </span>
                        ) : null}
                    </div>
                    <div className='title-actions'>
                        {loadedEventData ? (
                            <>
                                {(eventData.active != 1) ? (
                                    <span className='badge badge-error'><FontAwesomeIcon icon={faCircleInfo} /> Event inaktiv</span>
                                ) : (
                                    <span className='badge badge-open'><FontAwesomeIcon icon={faCircleInfo} /> Event aktiv</span>
                                )}
                                <a href={"/manage/event/edit/" + eventid} className='btn btn-secondary btn-sm'>
                                    <FontAwesomeIcon icon={faPen} /> Event bearbeiten
                                </a>
                            </>
                        ) : null}
                    </div>
                </div>

                {/* KPI-Karten */}
                <div className='kpi-row'>
                    <div className='card kpi-card'>
                        <span className='kpi-top'><FontAwesomeIcon icon={faCalendarCheck} /> Eingereichte Dienste</span>
                        <b>{loadedEventStats ? (eventStats.active_registeredschedules || 0) : '–'}</b>
                        <small>{loadedEventStats ? 'Nutzer mit Dienstplan' : <Skeleton height={10} width="80%" />}</small>
                    </div>
                    <div className='card kpi-card'>
                        <span className='kpi-top'><FontAwesomeIcon icon={faHourglassHalf} /> Alle Teilnehmer</span>
                        <b>{loadedEventStats ? (eventStats.all_users || 0) : '–'}</b>
                        <small>Gesamtanzahl</small>
                    </div>
                    <div className='card kpi-card'>
                        <span className='kpi-top'><FontAwesomeIcon icon={faUsers} /> Aktive User</span>
                        <b>{loadedEventStats ? (eventStats.active_users || 0) : '–'}</b>
                        <small>derzeit aktiv</small>
                    </div>
                </div>

                {/* Verwaltungs-Kacheln */}
                <div className='section-gap'>
                    <h2 style={{ fontSize: '24px' }}>Verwaltung</h2>
                    <div className='action-tiles' style={{ marginTop: '14px' }}>
                        <a href={"/manage/event/edit/" + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faEdit} /></span>
                            <b>Event bearbeiten</b>
                            <p>Texte, Bilder, Eckdaten, Anmeldezeitraum und Event-Design anpassen.</p>
                        </a>
                        <a href={"/manage/eventschedule/" + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faCalendar} /></span>
                            <b>Zeitplan bearbeiten</b>
                            <p>Bereiche, Schichtzeiten und Helferbedarf pro Schicht definieren.</p>
                        </a>
                        <a href={'/manage/eventattendees/' + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faPersonWalking} /></span>
                            <b>Helfer verwalten</b>
                            <p>Anmeldungen prüfen, Helfer manuell hinzufügen, Gruppen verwalten.</p>
                        </a>
                        <a href={'/manage/eventscheduleplan/' + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faPersonCircleCheck} /></span>
                            <b>Dienstpläne verwalten</b>
                            <p>Wunschdienste einsehen und Helfer auf Schichten einteilen.</p>
                        </a>
                        <a href={'/manage/eventmailings/' + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faEnvelope} /></span>
                            <b>Mails versenden</b>
                            <p>Informationen an alle Helfer versenden, Vorlagen verwalten.</p>
                        </a>
                        <a href={"/event/" + eventid} className='card card-hover action-tile'>
                            <span className='tile-icon'><FontAwesomeIcon icon={faChartSimple} /></span>
                            <b>Event-Seite ansehen</b>
                            <p>So sehen Helfer die Veranstaltung öffentlich.</p>
                        </a>
                    </div>
                </div>
            </main>

            <MainFooter useEventStyle={false} />
        </div>
    )
}
